// extracted by mini-css-extract-plugin
export default {"header":"FaHeaders_header__O5fgB","syncBtn":"FaHeaders_syncBtn__YF57D","rightSection":"FaHeaders_rightSection__2hDMQ","contentWrapper":"FaHeaders_contentWrapper__erd-6"};